import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../../../employee/service/web.service';

@Injectable()
export class CandidateVacanciesService extends WebService {
  public getVacancies(page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
    let params: URLSearchParams = new URLSearchParams();

    if (page !== null && page !== undefined)
      params.append('_page', String(page));
    else
      params.append('_page', '1');

    if (per_page !== null && per_page !== undefined)
      params.append('_limit', String(per_page));
    else
      params.append('_limit', '10');

    if (sort !== null && sort !== undefined)
      params.append('_sort', String(sort));

    if (query !== null && query !== undefined && query !== '')
      params.append('_q', String(query));

    if (filters !== null && filters !== undefined && filters.length > 0) {
      filters.forEach(element => {
        params.append(element.key, String(element.value));
      });
    }

    // params.append('_with', String('employee,company,venue,profile_survey,citation,requisition_justification.user.employee,requisition_task.employee,requisition_task.created_by,destination'));

    const options = new RequestOptions({ search: params, headers: this.headers });

    return this.http.get(`${this.apiUrl}/candidate-vacancies?${params}`, options);
  }

  public updateVacancie(id: number, body: Object): Observable<Response> {
    return this.http.patch( `${this.apiUrl}/candidate-vacancies/${id}`, JSON.stringify(body) , { headers: this.headers } );
  }

  public applyToVacancie(body: Object): Observable<Response> {
    return this.http.post( `${this.apiUrl}/candidate-vacancies`, JSON.stringify(body), { headers: this.headers } );
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/candidate/services/candidate-vacancies/candidate-vacancies.service.ts